module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('b-button', {
    staticClass: "ml-1 mr-1",
    staticStyle: {
      "font-size": "0.675rem",
      "margin-left": "5px",
      "margin-bottom": "4px"
    },
    attrs: {
      "size": "sm",
      "variant": "warning"
    },
    on: {
      "click": function($event) {
        _vm.FilterClinet()
      }
    }
  }, [_vm._v("Client Search")]), _vm._v(" "), _c('b-modal', {
    ref: "FilterClinet-modal",
    attrs: {
      "id": "FilterClinet-modal",
      "title": "Filter Client",
      "size": "xl",
      "no-close-on-esc": "",
      "no-close-on-backdrop": "",
      "hide-footer": ""
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-8"
  }, [_c('b-form-input', {
    staticClass: "mb-2 w-100",
    attrs: {
      "formatter": _vm.capitalizeAll,
      "placeholder": "Type to Search"
    },
    on: {
      "keyup": function($event) {
        _vm.ClientFilterFunct(true)
      }
    },
    model: {
      value: (_vm.filterClientName),
      callback: function($$v) {
        _vm.filterClientName = $$v
      },
      expression: "filterClientName"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('b-button', {
    on: {
      "click": function($event) {
        _vm.ClientFilterFunct(false)
      }
    }
  }, [_vm._v("Clear")]), _vm._v(" "), _c('strong', [_vm._v(_vm._s(_vm.getClientNameDocList.length) + " Entries")])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [_c('h1', [_vm._v(_vm._s(_vm.DataSearch))]), _vm._v(" "), (_vm.isLoading) ? _c('CustomLoader', {
    attrs: {
      "width": 70
    }
  }) : _vm._e(), _vm._v(" "), (_vm.getClientNameList.clientName) ? _c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-header"
  }, [_c('a', {
    attrs: {
      "href": _vm.DataSearch,
      "target": "_blank"
    }
  }, [_vm._v(_vm._s(_vm.getClientNameList.clientName))])]), _vm._v(" "), _c('div', {
    staticClass: "card-body"
  }, [_c('div', {
    staticClass: "client-details"
  }, [_c('b-row', [_c('b-col', {
    attrs: {
      "md": "4"
    }
  }, [_c('p', [_c('strong', [_vm._v("Type : ")]), _vm._v(_vm._s(_vm.getClientNameList.clientType) + "\n                  ")])]), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "4"
    }
  }, [_c('p', [_c('strong', [_vm._v("Name : ")]), _vm._v(_vm._s(_vm.getClientNameList.clientName) + "\n                  ")])]), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "4"
    }
  }, [_c('p', [_c('strong', [_vm._v("Email : ")]), _vm._v(_vm._s(_vm.getClientNameList.email))])]), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "4"
    }
  }, [_c('p', [_c('strong', [_vm._v("Contact No : ")]), _vm._v(_vm._s(_vm.getClientNameList.phoneKYC) + "\n                  ")])]), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "4"
    }
  }, [_c('p', [_c('strong', [_vm._v("Alternate Email : ")]), _vm._v(_vm._s(_vm.getClientNameList.altMail) + "\n                  ")])]), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "4"
    }
  }, [_c('p', [_c('strong', [_vm._v("PAN No. : ")]), _vm._v(_vm._s(_vm.getClientNameList.panNO) + "\n                  ")])]), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "4"
    }
  }, [_c('p', [_c('strong', [_vm._v("IEC Number : ")]), _vm._v(_vm._s(_vm.getClientNameList.IEC) + "\n                  ")])]), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "4"
    }
  }, [_c('p', [_c('strong', [_vm._v("Type of Company : ")]), _vm._v(_vm._s(_vm.getClientNameList.companyType) + "\n                  ")])]), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "4"
    }
  }, [_c('p', [_c('strong', [_vm._v("State : ")]), _vm._v(_vm._s(_vm.getClientNameList.stateName) + "\n                  ")])]), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "4"
    }
  }, [_c('p', [_c('strong', [_vm._v("Company Permitted : ")]), _vm._v(_vm._s(_vm.getClientNameList.permitted) + "\n                  ")])]), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "4"
    }
  }, [_c('p', [_c('strong', [_vm._v("TAN No : ")]), _vm._v(_vm._s(_vm.getClientNameList.tanNO))])]), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "4"
    }
  }, [_c('p', [_c('strong', [_vm._v("GSTN Code : ")]), _vm._v(_vm._s(_vm.getClientNameList.gstCode))])]), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "4"
    }
  }, [_c('p', [_c('strong', [_vm._v("GSTN No : ")]), _vm._v(_vm._s(_vm.getClientNameList.gstCode + _vm.getClientNameList.GSTN))])]), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "4"
    }
  }, [_c('p', [_c('strong', [_vm._v("Corporate Address : ")]), _vm._v(_vm._s(_vm.getClientNameList.corporateAddress) + "\n                  ")])]), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "4"
    }
  }, [_c('p', [_c('strong', [_vm._v("Credit Days : ")]), _vm._v(_vm._s(_vm.getClientNameList.creditDays) + "\n                  ")])]), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "4"
    }
  }, [_c('p', [_c('strong', [_vm._v("Remarks : ")]), _vm._v(_vm._s(_vm.getClientNameList.remarkOtherDocument) + "\n                  ")])]), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "4"
    }
  }, [_c('b-button', {
    staticStyle: {
      "font-size": "0.675rem"
    },
    attrs: {
      "size": "sm",
      "variant": "primary"
    },
    on: {
      "click": function($event) {
        _vm.downloadZip(_vm.getClientNameList)
      }
    }
  }, [_vm._v("Download Zip")])], 1)], 1)], 1)])]) : _vm._e(), _vm._v(" "), (_vm.getClientNameDocList.length > 0) ? _c('b-table', {
    attrs: {
      "show-empty": "",
      "stacked": "md",
      "items": _vm.getClientNameDocList,
      "fields": _vm.fields,
      "per-page": _vm.perPage,
      "sort-by": _vm.sortBy,
      "sort-desc": _vm.sortDesc,
      "sort-direction": _vm.sortDirection
    },
    on: {
      "update:sortBy": function($event) {
        _vm.sortBy = $event
      },
      "update:sortDesc": function($event) {
        _vm.sortDesc = $event
      }
    },
    scopedSlots: _vm._u([{
      key: "SN",
      fn: function(row0) {
        return [_c('span', [_vm._v(_vm._s(row0.index + 1 + (_vm.currentPage - 1) * _vm.perPage))])]
      }
    }, {
      key: "kycDocName",
      fn: function(row1) {
        return [(row1.item.kycDocName) ? _c('span', [_vm._v("\n              " + _vm._s(row1.item.kycDocName) + "\n            ")]) : _vm._e()]
      }
    }, {
      key: "uploadedkycDoc",
      fn: function(row2) {
        return [(row2.item.uploadedkycDoc != '') ? _c('a', {
          staticClass: "showMoreData",
          attrs: {
            "href": _vm.docURL + "/" +
              "" + (row2.item.uploadedkycDoc.includes('CLIENTKYCDOC')
                    ? ''
                    : 'CLIENTKYCDOC/') +
              row2.item.uploadedkycDoc,
            "target": "_blank",
            "download": ""
          }
        }, [_c('u', [_vm._v("View Document -" + _vm._s(row2.index + 1))])]) : _vm._e()]
      }
    }])
  }) : _vm._e()], 1)]), _vm._v(" "), _c('b-button', {
    staticClass: "pull-right mt-2",
    attrs: {
      "variant": "danger"
    },
    on: {
      "click": _vm.hideFilterClinet
    }
  }, [_vm._v("\n      Close")])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7c044416","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/component/common/clientCard.vue
// module id = 2770
// module chunks = 0